import "react-toastify/dist/ReactToastify.css";
import { TYPES } from "../../common/constants";
import * as client from "../../services/client";
import { startPRLoading, stopPRLoading } from "../actions/loader";
import { onFetchOnboardingOrders, clearOrders } from "./HomeOwnerOnboardingDashboard";
import { store } from "..";
const fetchUserSuitesDone = (payload) => ({
  type: TYPES.FETCH_USER_SUITES,
  payload,
});

export const fetchUserSuites = (userId, loader, role) => (dispatch) => {
  if (loader === false) {
  } else {
    dispatch(startPRLoading());
  }
  return client.getSuitesByUser(userId,role).then((response) => {
    if (response.status === 200) {
      response
        .json()
        .then((responsejson) => {
          if(responsejson && responsejson.length > 0) {    
          if(loader === 'logincall'){
            if(localStorage.getItem("user").isDashboardAccess===false) {
              localStorage.setItem('suiteId', responsejson[0].id);
            }
          }
          const {propertyId,id}=store.getState().userSuites?.selectedUserSuite;
          if(propertyId && id)
          {
            dispatch(clearOrders())
            dispatch(onFetchOnboardingOrders(propertyId, id, userId));
          }else{
          dispatch(fetchUserSuitesDone(responsejson));
          dispatch(setCurrentUserSuite(responsejson[0]));
          // if(responsejson[0] && responsejson[0].status !== 'Occupied') {
            dispatch(clearOrders())
            dispatch(onFetchOnboardingOrders(responsejson[0].propertyId, responsejson[0].id, userId));
        // }
          }
        }
          dispatch(stopPRLoading());
        });
    } else if (response.status === 204) {
      dispatch(fetchUserSuitesDone([]));
      dispatch(stopPRLoading());
    } else {
      dispatch(stopPRLoading());
    }
  }).catch(() => {
    dispatch(stopPRLoading());
  })
};

export const setCurrentUserSuite = (payload) => ({
  type: TYPES.SET_USER_SUITE,
  payload,
});
